import React from 'react';
import SearchResultTable from '../../components/statistics/SearchResultTable';
import DownloadExcel from '../../components/common/DownloadExcel';
import MembershipStatisticsDownloadExcel from '../../components/common/MembershipStatisticsDownloadExcel';
import palette from '../../lib/styles/palette';
import { timeValueToDate } from '../../lib/commonFunc/commonFunc';

const StatisticsResult = ({
  activeTab,
  memberResult,
  membershipResult,
  onClickMember,
  loading,
}) => {
  // 데이터 존재 여부 확인
  const hasMemberData = activeTab === 'member' && memberResult && memberResult.length > 0;
  const hasMembershipData = activeTab === 'membership' && membershipResult && membershipResult.membershipList && membershipResult.membershipList.length > 0;
  const hasData = hasMemberData || hasMembershipData;

  console.log('memberResult : ', memberResult);
  return (
    <>
      {hasMemberData && (
        <DownloadExcel
          dataSet={memberResult.map((item) => ({
            ...item,
            sex: item.sex === '남자' ? 1 : 2,
            registTime: timeValueToDate(item.registTime),
          }))}
        />
      )}

      {hasMembershipData && (
        <MembershipStatisticsDownloadExcel dataSet={membershipResult.membershipList} />
      )}

      {hasData && (
        <SearchResultTable
          data={activeTab === 'member' ? memberResult : membershipResult.membershipList}
          onClick={onClickMember}
          membershipStatisticsResult={membershipResult.result}
          activeTab={activeTab}
          loading={loading}
        />
      )}

      {hasMemberData && (
        <div
          style={{
            color: palette.webCyan[5],
            paddingBottom: '1rem',
            paddingLeft: '2rem',
            fontSize: '0.9rem',
            marginTop: '1.5rem',
          }}
        >
          ※조회 결과의 회원권과 상태는 검색 기간(시점)의 상태가 아닌 현재 기준입니다.
        </div>
      )}
    </>
  );
};

export default StatisticsResult;


